import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  count: number;
  title: React.ReactNode;
};

const Root = styled.div`
  display: flex;
  align-items: center;
`;

export const BulkActionModalTitle = ({ count, title }: Props) => {
  return (
    <Root>
      {title}
      <Tag variant="lightBlue" size="small" style={{ marginInlineStart: '8px', textTransform: 'uppercase' }}>
        <FormattedMessage
          id="menu.bulkActions.itemCount"
          values={{
            count,
          }}
        />
      </Tag>
    </Root>
  );
};
